import { render, staticRenderFns } from "./Cinch.vue?vue&type=template&id=6615a02f&scoped=true"
import script from "./Cinch.vue?vue&type=script&lang=js"
export * from "./Cinch.vue?vue&type=script&lang=js"
import style0 from "./Cinch.vue?vue&type=style&index=0&id=6615a02f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6615a02f",
  null
  
)

export default component.exports